<template>
  <!-- 国家及地区英文 -->
  <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
    <a-row>
      <a-col :span="6">
        <form-input label="词条KEY" v-model:value="params.keyName"></form-input>
      </a-col>

      <a-col :span="6">
        <form-select
          label="语言"
          v-model:value="params.languageId"
          :showSearch="true"
          :filterOption="filterOption"
        >
          <a-select-option
            :value="item.id"
            v-for="item in lang"
            :key="item.langEn"
          >
            {{ item.langEn }}
          </a-select-option>
        </form-select>
      </a-col>
      <a-col :span="6">
        <form-input
          label="语言文案"
          v-model:value="params.valueName"
        ></form-input>
      </a-col>
      <a-col :span="6" class="tar">
        <a-button type="primary" class="mr10" @click="changePage(1)"
          >查询</a-button
        >
        <a-button @click="add">单个新增</a-button>
      </a-col>
    </a-row>

    <a-row>
      <!-- 状态 -->
      <a-col :span="6">
        <form-select label="归属系统" v-model:value="params.systemId">
          <a-select-option
            :value="item.id"
            v-for="(item, key) in systems"
            :key="key"
          >
            {{ item.code }}
          </a-select-option>
        </form-select>
      </a-col>
      <a-col :span="6">
        <form-input label="更新人" v-model:value="params.userName"></form-input>
      </a-col>
      <a-col :span="6">
        <a-form-item label="更新时间">
          <a-range-picker v-model:value="updateTime" valueFormat="YYYY-MM-DD" />
        </a-form-item>
      </a-col>

      <a-col :span="6" class="tar">
        <a-button type="primary" class="mr10" @click="exportExcel()"
          >导出</a-button
        >
        <a-upload
          v-model:file-list="fileList"
          name="file"
          :showUploadList="false"
          :action="action"
          :headers="headers"
          @change="handleChange"
        >
          <a-button>批量导入</a-button>
        </a-upload>
      </a-col>
    </a-row>
  </a-form>
  <!-- </a-card> -->
  <EventAlert v-if="visible" />
</template>
<script>
import { language_key_export_get } from 'server/modules/351.js'
import { inject, reactive, toRefs } from 'vue'
import { message } from 'ant-design-vue'
import EventAlert from './EventAlert.vue'
export default {
  components: {
    EventAlert
  },
  setup() {
    const state = inject('state')
    const useCount = inject('useCount')
    const searchState = reactive({
      fileList: [],
      headers: {
        Authorization: localStorage.getItem('token')
      },
      action: `${process.env.VUE_APP_LANGUAGE}/language/key/upload`,
      handleChange(info) {
        if (info.file.status !== 'uploading') {
          // console.log(info.file, info.fileList)
        }
        if (info.file.status === 'done') {
          const { success, retInfo } = info.file.response
          if (success) {
            state.changePage(1)
            message.success(`${info.file.name} file uploaded successfully`)
          } else {
            message.error(retInfo)
          }
        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} file upload failed.`)
        }
      },
      add() {
        const { setAttrs, setEmpty } = state
        setAttrs('visible', true)
        setEmpty()
      },
      async exportExcel() {
        const { success } = await language_key_export_get(state.params)
        if (success) {
          useCount.count++
        }
      },
      filterOption(input, option) {
        return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    })
    return {
      labelCol: { span: 10 },
      wrapperCol: { span: 14 },
      ...toRefs(searchState),
      ...toRefs(state)
    }
  }
}
</script>
